import React, { useCallback, useEffect, useMemo, useState } from 'react';
// Components
import SelectAutoComplete from 'components/Tvendo/Common/SelectAutoComplete';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';
import GridContainer from 'components/Grid/GridContainer';
import Modal from 'components/Tvendo/Common/ModalBase';
import GridItem from 'components/Grid/GridItem';
import Table from 'components/Table/Table';
//
import Checkbox from '@material-ui/core/Checkbox';
import { wsGetAll } from 'services/WService';
import RegularButton from 'components/CustomButtons/Button';
import { wsCreate } from 'services/WService';

function ReplaceSellerModal(props) {
  const { showNotify } = props;
  const [sellers, setSellers] = useState([]);
  const [processing, setProcessing] = useState(false);
  const [selectedFromSeller, setSelectedFromSeller] = useState(undefined);
  const [fromSellerPortfolios, setFromSellerPortfolios] = useState(undefined);
  const [selectedPortfoliosIds, setSelectedPortfolioIds] = useState([]);

  const [selectedToSeller, setSelectedToSeller] = useState(undefined);
  const [toSellerPortfolios, setToSellerPortfolios] = useState(undefined);

  async function listSellers() {
    let res = await wsGetAll('base/seller?seller_type=S');
    if (res.success) {
      setSellers(res.data);
    }
  }

  async function listSellerPortfolios(seller, setPortfolios, setSelectedPortfolioIds = undefined) {
    setPortfolios(null);
    let res = await wsGetAll(`base/customer-portfolio-bureau?base_seller_id=${seller.id}`);
    if (res.success) {
      setPortfolios(res.data);
      if (setSelectedPortfolioIds !== undefined) {
        setSelectedPortfolioIds(res.data.map((portfolio) => portfolio.id));
      }
    }
  }

  async function save() {
    // Validación de zonas
    let zones = [];
    for (let portfolio of toSellerPortfolios) {
      if (zones.includes(portfolio.base_zone_id)) continue;
      zones.push(portfolio.base_zone_id);
    }

    for (let portfolio of fromSellerPortfolios) {
      if (zones.includes(portfolio.base_zone_id)) continue;
      zones.push(portfolio.base_zone_id);
    }

    if (zones.length > 1) {
      if (!window.confirm('El vendedor tiene varias zonas ¿Seguro de continuar?')) return;
    }

    let data = {
      from_seller_id: selectedFromSeller.id,
      to_seller_id: selectedToSeller.id,
      customer_portfolio_bureaus: selectedPortfoliosIds,
    };

    setProcessing(true);
    let res = await wsCreate('base/customer-portfolio-bureau/replace-seller', data);
    if (res.success) {
      setProcessing(false);
      showNotify(res.message);
      props.setOpen({ open: false });
    } else {
      setProcessing(false);
      showNotify(res.message, 'error');
    }
  }

  const nextOptions = useMemo(() => {
    if (sellers.length === 0 || selectedFromSeller === undefined) return sellers;
    let nextOptions = [...sellers];
    let index = nextOptions.findIndex((seller) => seller.id === selectedFromSeller.id);
    if (index !== -1) {
      nextOptions.splice(index, 1);
    }
    return nextOptions;
  }, [sellers, selectedFromSeller]);

  const [allSelect, indeterminated] = useMemo(() => {
    if (fromSellerPortfolios === undefined || fromSellerPortfolios === null) {
      return [false, false];
    }
    let allSelect = false,
      indeterminated = false;

    if (selectedPortfoliosIds.length > 0) {
      if (fromSellerPortfolios.length === selectedPortfoliosIds.length) {
        allSelect = true;
      } else {
        indeterminated = true;
      }
    }
    return [allSelect, indeterminated];
  }, [fromSellerPortfolios, selectedPortfoliosIds]);

  const toggleCheckbox = useCallback(() => {
    if (allSelect) {
      setSelectedPortfolioIds([]);
      return;
    }
    if (indeterminated) {
      setSelectedPortfolioIds([]);
      return;
    }

    setSelectedPortfolioIds(fromSellerPortfolios.map((portfolio) => portfolio.id));
  }, [allSelect, indeterminated, fromSellerPortfolios, selectedPortfoliosIds]);

  useEffect(() => {
    listSellers();
  }, []);

  useEffect(() => {
    if (props.model.open === false) {
      setSelectedFromSeller(undefined);
      setFromSellerPortfolios(undefined);
      setSelectedPortfolioIds([]);
      setSelectedToSeller(undefined);
      setToSellerPortfolios(undefined);
    }
  }, [props.model]);

  return (
    <Modal
      title="Transferir carteras"
      maxWidth="md"
      fullWidth
      model={props.model}
      setOpen={props.setOpen}
      handleCloseDisabled={processing}
      entity=""
      disabledSave
      hideSave
      footerComponent={
        <RegularButton
          color="success"
          size="sm"
          onClick={save}
          disabled={
            processing ||
            selectedPortfoliosIds.length === 0 ||
            selectedToSeller === undefined ||
            !Array.isArray(toSellerPortfolios)
          }
        >
          Reemplazar
        </RegularButton>
      }
    >
      <GridContainer>
        {/* Vendedor Origen */}
        <GridItem xs={12}>
          <SelectAutoComplete
            label="Vendedor Origen"
            textField="SlpName"
            required
            options={sellers}
            selectedOption={selectedFromSeller}
            setSelectedOption={setSelectedFromSeller}
            onChange={(item) => {
              if (item === undefined) {
                setFromSellerPortfolios(undefined);
                setSelectedPortfolioIds([]);
                setSelectedToSeller(undefined);
                setToSellerPortfolios(undefined);
                return;
              }
              listSellerPortfolios(item, setFromSellerPortfolios, setSelectedPortfolioIds);
            }}
          />
        </GridItem>
        {/* Carteras del vendedor origen */}
        {fromSellerPortfolios !== undefined && (
          <GridItem xs={12}>
            {fromSellerPortfolios === null && <LoadingSpinner />}
            {Array.isArray(fromSellerPortfolios) && (
              <Table
                tableHead={[
                  <Checkbox
                    margin="normal"
                    checked={allSelect}
                    indeterminate={indeterminated}
                    onChange={toggleCheckbox}
                  />,
                  'Mesa',
                  'Zona',
                  'Cartera',
                  'Día de visita',
                  'Ruta',
                  'Frecuencia',
                  'Estado',
                ]}
                tableData={fromSellerPortfolios.map((portfolio) => {
                  return [
                    <Checkbox
                      margin="normal"
                      checked={selectedPortfoliosIds.includes(portfolio.id)}
                      onChange={(e) => {
                        let index = selectedPortfoliosIds.findIndex((id) => id === portfolio.id);
                        // Agregando
                        if (index === -1) {
                          setSelectedPortfolioIds((portfolioIds) => [
                            ...portfolioIds,
                            portfolio.id,
                          ]);
                        } else {
                          // Quitando
                          let newSelected = [...selectedPortfoliosIds];
                          newSelected.splice(index, 1);
                          setSelectedPortfolioIds(newSelected);
                        }
                      }}
                    />,
                    // Mesa
                    portfolio.base_bureau_description,
                    // Zona
                    portfolio.base_zone_description,
                    // Cartera
                    portfolio.base_customer_portfolio_description,
                    // Día de visita
                    portfolio.base_visit_day_description,
                    // Ruta
                    portfolio.base_route_description,
                    // Frecuencia
                    portfolio.frequency === 'W' ? 'Semanal' : portfolio.frequency,
                    // Estado
                    portfolio.state === 'A' ? 'Activo' : 'Inactivo',
                  ];
                })}
              />
            )}
          </GridItem>
        )}
        {/* Vendedor Destino */}
        <GridItem xs={12}>
          <SelectAutoComplete
            label="Vendedor Destino"
            textField="SlpName"
            required
            disabled={selectedFromSeller === undefined}
            options={nextOptions}
            selectedOption={selectedToSeller}
            setSelectedOption={setSelectedToSeller}
            onChange={(item) => {
              if (item === undefined) {
                setToSellerPortfolios(undefined);
                return;
              }
              listSellerPortfolios(item, setToSellerPortfolios);
            }}
          />
        </GridItem>
        {/* Carteras del vendedor destino */}
        {toSellerPortfolios !== undefined && (
          <GridItem xs={12}>
            {toSellerPortfolios === null && <LoadingSpinner />}
            {Array.isArray(toSellerPortfolios) && (
              <Table
                tableHead={[
                  'Mesa',
                  'Zona',
                  'Cartera',
                  'Día de visita',
                  'Ruta',
                  'Frecuencia',
                  'Estado',
                ]}
                tableData={toSellerPortfolios.map((portfolio) => {
                  return [
                    // Mesa
                    portfolio.base_bureau_description,
                    // Zona
                    portfolio.base_zone_description,
                    // Cartera
                    portfolio.base_customer_portfolio_description,
                    // Día de visita
                    portfolio.base_visit_day_description,
                    // Ruta
                    portfolio.base_route_description,
                    // Frecuencia
                    portfolio.frequency === 'W' ? 'Semanal' : portfolio.frequency,
                    // Estado
                    portfolio.state === 'A' ? 'Activo' : 'Inactivo',
                  ];
                })}
              />
            )}
          </GridItem>
        )}
      </GridContainer>
    </Modal>
  );
}

export default ReplaceSellerModal;
